const headerElementsToRemove: string[] = [
  'a#HFExpandServicesButton',
  '#HFRightTools.hf-navbar-nav .hf-iconButton',
  '#HFPWProjectsAnchor',
  '#HFProjectDropDownAnchor',
  '.hf-nav.hf-navbar-nav:nth-child(1)',
  '#HFPWProjectsAnchor',
  '.hf-navbar-nav.hf-breadcrumb-navbar .hf-breadcrumb:before',
];

const headerElementsToRemoveString: string = `nav#GlobalHeader ${headerElementsToRemove
  .join(', nav#GlobalHeader ')
  .concat('{display: none;}')}`;

const HEADER_HEIGHT = '34px';

export const sharedCalls = ({ child }) => {
  child.call('clickElement', {
    selector: '.hopscotch-tour-skip',
  });

  child.call('globalStyles', {
    styles: 'html, body {height: calc(100% - 4px);}',
    id: 'bodyheight',
  });
  child.call('globalStyles', {
    styles: 'nav#GlobalHeader{display:none;}',
    id: 'displayNoneHeader',
  });

  child.call('injectStyles', {
    styles: 'bottom: 11px; height: 36px;',
    id: 'connect-footer',
  });
  // child.call('globalStyles', {
  //   styles: headerElementsToRemoveString,
  //   id: 'headerModifications',
  // })

  child.call('globalStyles', {
    styles:
      'nav#GlobalHeader #HFProjectLink{ pointer-events: none; cursor: default;}',
    id: 'headerPreventProjectClick',
  });

  child.call('globalStyles', {
    styles:
      '#GlobalHeader .hf-navbar-nav > li.tab-active > :not(.hf-dropdown-menu), #GlobalHeader .hf-navbar-nav > li.tab-active {background-color: transparent}',
    id: 'headerProjectHighlight',
  });

  child.call('globalStyles', {
    styles: `#GlobalHeader {line-height: 1.3;} #GlobalHeader #HFNavBar {height: ${HEADER_HEIGHT}; min-height: ${HEADER_HEIGHT}; } #GlobalHeader .hf-navbar-nav #HFProjectLink span {display: inline-block;} #GlobalHeader .hf-navbar-nav #HFProjectLink.hf-current-project{height: auto} #GlobalHeader .hf-navbar-nav>li {height: ${HEADER_HEIGHT}} #GlobalHeader #HFNavbarCollapse{height: ${HEADER_HEIGHT};} #GlobalHeader .hf-navbar-nav #HFProjectLink span{font-size: 13px} #HFCurrentProjectCode{margin-right: 3px} #HFCurrentProjectCode:after{content: " | "} #GlobalHeader .hf-navbar-nav.hf-breadcrumb-navbar .hf-breadcrumb{padding-left:10px;} #GlobalHeader .hf-navbar-nav #HFProjectLink span{color: #000; font-weight:bold;} #HFNavBarContainer{background-color: #f3f2f1;}`,
    id: 'squish-header',
  });

  child.call('globalStyles', {
    styles: '#GlobalHeader #HFCurrentProjectTab:after{display:none;}',
    id: 'headerRemoveBottomBorder',
  });

  child.call('globalStyles', {
    styles:
      '#GlobalHeader .hf-navbar-nav .initialsBadge{height: 20px; width: 20px; border-radius: 30vh;} #GlobalHeader .hf-navbar-nav .initialsBadge #HFProfileAnchor{width: 20px; height: 20px;} #GlobalHeader .hf-navbar-nav .initialsBadge > span {font-size: 10px; font-weight: bold; width: 19px; height: 19px; line-height: 18px;} #GlobalHeader .HFName, #HFViewProfileModal .HFName{margin-top: 4px; margin-bottom: 10px;} #GlobalHeader .hf-navbar-nav .initialsBadge #HFProfileAnchor .caret {top: -2px; left: 26px;}',
    id: 'badge-restyles',
  });

  // Hopscotch related methods:

  child.call('clickElement', {
    selector: '.hopscotch-tour-skip',
  });

  child.call('removeElement', { id: 'newFeatureModal' });

  // child.call('removeElement', {
  //   class: 'modal-backdrop',
  // })

  // child.call('removeElement', {
  //   class: 'hopscotch-bubble',
  // })
};
